'use client'

import type { ImagePlaceholderProps } from '@maestro/commerce-blocks/components/image-product/image-product.types'

import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import React from 'react'

import { useImagePlaceholder } from '@maestro/commerce-blocks/components/image-product/batons/use-image-placeholder'

export default function ImagePlaceholder(props: ImagePlaceholderProps) {
  const {
    src,
    blurDataUrl,
    cachedUrl,
    width = 80,
    height = 80,
    isLoaded,
    cacheKey,
    loading = 'lazy',
  } = props
  const t = useTranslations('commerce-blocks')
  const { placeholderSrc } = useImagePlaceholder({
    src,
    blurDataUrl,
    cachedUrl,
    cacheKey,
  })

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      className={classNames(
        'image-product__image',
        'image-product__image--placeholder',
        { 'image-product__image--hide': isLoaded }
      )}
      src={placeholderSrc}
      width={width}
      height={height}
      alt={t('image-product.placeholder')}
      loading={loading}
    />
  )
}
